import React, { useState, useEffect } from 'react';
import { Modal, Button, InputGroup, FormControl } from 'react-bootstrap';
import { updateDb } from "../services/updateDb";
import AlertMessage from "../common/AlertMessage";
import { useAppContext } from "../AppContext";
import { useTranslation } from "react-i18next";

const TwoFactorAuthModal = ({show, handleClose, refetchUserData, twoFactorEnabledInitial}) => {
  const { t } = useTranslation();
  const { showAlertMessage, alertMessage, clearAlertMessage } = useAppContext();
  const [qrCode, setQrCode] = useState(null);
  const [token, setToken] = useState("");
  const [password, setPassword] = useState("");
  const [twoFactorEnabled, setTwoFactorEnabled] = useState(twoFactorEnabledInitial);

  useEffect(() => {
    if (show && !twoFactorEnabled) {
      handleEnable2FA();
    }
  }, [show, twoFactorEnabled]);

  // Function to handle enabling 2FA
  const handleEnable2FA = async () => {
    const res = await updateDb('/api/users/2fa/setup');
    if (res.success && res.data.qrCodeImageUrl) {
      setQrCode(res.data.qrCodeImageUrl);
      setTwoFactorEnabled(false); // Assuming 2FA is not enabled yet
    } else {
      showAlertMessage('error', res.error ? res.error : 'Error enabling 2FA.');
    }
  };

  // Function to handle disabling 2FA
  const handleDisable2FA = async () => {
  
    const res = await updateDb('/api/users/2fa/disable', { twoFactorToken: token, password });
    if (res.success) {
      showAlertMessage('success', '2FA ' + t('disabled'));
      setQrCode(null);
      setTwoFactorEnabled(false);
      refetchUserData(); // Refetch user data to update 2FA status
      handleClose();
    } else {
      // Handle any error responses here
      showAlertMessage('error', res.error ? res.error : 'Error disabling 2FA.');
    }
  };

  // Function to verify the 2FA token
  const handleVerifyToken = async () => {
  
    const res = await updateDb('/api/users/2fa/verify', { token, password }, "post");
    if (res.success) {
      showAlertMessage('success', '2FA ' + t('enabled'));
      setQrCode(null); // Hide QR code after successful verification
      setTwoFactorEnabled(true); // Update state to indicate 2FA is enabled
      refetchUserData(); // Refetch user data to update 2FA status
      handleClose();
    } else {
      showAlertMessage('error', res.error ? res.error : 'Error verifying 2FA.');
    }
  };

  return (
    <Modal show={show} onHide={handleClose}>
      <Modal.Header closeButton>
        <Modal.Title>{twoFactorEnabled ? t('disable') + ' 2FA' : t('enable') + ' 2FA'}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <AlertMessage type={alertMessage.type} message={alertMessage.content} />
        {qrCode && (
          <>
            <p>{t('scan_qr_and_enter_token')}</p>
            <img src={qrCode} alt="2FA QR Code" />
            <InputGroup className="mb-3">
              <FormControl
                placeholder={t('enter_token')}
                value={token}
                onChange={(e) => setToken(e.target.value)}
              />
            </InputGroup>
            <InputGroup className="mb-3">
              <FormControl
                placeholder={t('enter_password')}
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
              />
            </InputGroup>
            {/* <Button onClick={handleVerifyToken}>Verify Token</Button> */}
          </>
        )}
        {twoFactorEnabled && (
        <>
            <p>{t('fill_in_otp_to_disable_2fa')}:</p>
            <InputGroup className="mb-3">
                <FormControl
                    placeholder="OTP"
                    value={token}
                    onChange={(e) => setToken(e.target.value)}
                />
            </InputGroup>
            <InputGroup className="mb-3">
                <FormControl
                    placeholder={t('enter_password')}
                    type="password"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                />
            </InputGroup>
        </>
        )}
      </Modal.Body>
      <Modal.Footer>
        <div className="white-border-btn cancel-btn" onClick={handleClose}>
          {t('cancel')}
        </div>
        {twoFactorEnabled ? (
          <div className="white-border-btn submit-btn" onClick={handleDisable2FA}>
            {t('disable')} 2FA
          </div>
        ) : (
          <div className="white-border-btn submit-btn" onClick={handleVerifyToken}>
            {t('verify_token_and_enable_2fa')}
          </div>
        )}
      </Modal.Footer>
    </Modal>
  );
};

export default TwoFactorAuthModal;